import React from "react";
import { ColorCodeType, DatesType } from "./MonthlyCalendar";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Button, useTheme } from "@mui/material";

import { IScheduleEvent } from "../../redux/reducers/schedule.reducer";

import LoadMonthEvents from "./LoadMonthEvents";
import {
  IFacilityOption,
  eventForm,
} from "../CalendarForms/Types/calendarTypes";

type MonthlyPropsType = {
  dates: DatesType[];
  setShowingEventForm: React.Dispatch<React.SetStateAction<eventForm>>;
  selectedFacility: null | IFacilityOption;
  allEvents: IScheduleEvent[];
  setSelectedEvent: React.Dispatch<React.SetStateAction<IScheduleEvent | null>>;
  setShowAssignEmployeeModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowEditModal: React.Dispatch<React.SetStateAction<boolean>>;
  colorCodes: ColorCodeType;
};

export default function Month(props: MonthlyPropsType) {
  const {
    dates,
    allEvents,
    setShowEditModal,
    setSelectedEvent,
    setShowingEventForm,
    colorCodes,
  } = props;

  const theme = useTheme();

  function handleEventSelect(e: any, selectedEvent: IScheduleEvent) {
    setSelectedEvent(selectedEvent);
    setShowEditModal(true);
  }

  function handleAddEventClick(selectedDate: string) {
    setShowingEventForm({ visible: true, preselectedDate: selectedDate });
  }

  function renderDates() {
    let rows = [];
    if (dates.length) {
      let index = 0;
      for (let i = 0; i < 6; i++) {
        let row = [];
        for (let j = 0; j < 7; j++) {
          let dateInfo = dates[index];
          let isCurrentMonth = dates[index].isCurrentMonth;
          let isScheduleAddable = dates[index].isScheduleAddable;
          let isCurrentDate = dates[index].isCurrentDate;

          row.push(
            //render each dates from array
            <Box
              key={i + "key" + index}
              className="date-container"
              sx={{
                width: "14.28%",
                padding: "0.5rem 0.3rem",
                textAlign: "left",
                fontSize: "0.8rem",
                border: "1px solid",
                borderColor: "text.secondary",
                borderRight: "none",
                borderTop: "none",
                opacity: `${isCurrentMonth ? "1" : "0.6"}`,
                backgroundColor: isCurrentDate
                  ? `${theme?.palette?.primary?.main}22`
                  : "",
              }}
            >
              <Box
                className="date-info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                padding="0.5rem 0.3rem"
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: "0.875rem",
                    border: `${isCurrentDate ? "1px solid" : ""}`,
                    backgroundColor: `${isCurrentDate ? "primary.main" : ""}`,
                    color: `${isCurrentDate ? "#ffffff" : "text.primary"}`,
                    borderRadius: "50%",
                    height: "26px",
                    textAlign: "center",
                    width: "26px",
                  }}
                >
                  {dateInfo.date}
                </Typography>
                {isScheduleAddable && (
                  <Button
                    type="button"
                    variant="contained"
                    disabled={isScheduleAddable ? false : true}
                    sx={{
                      height: "24px",
                      width: "50px",
                      minWidth: "24px",
                      padding: 0,
                    }}
                    onClick={() => {
                      handleAddEventClick(dateInfo?.fullDate);
                    }}
                  >
                    +
                  </Button>
                )}
              </Box>
              <Box
                className="events-container"
                sx={{
                  padding: "0.5rem 0.5rem 0 0 ",
                }}
              >
                {/* render months in current date from all events list */}
                <LoadMonthEvents
                  allEvents={allEvents}
                  fullDate={dateInfo.fullDate}
                  handleEventSelect={handleEventSelect}
                  colorCodes={colorCodes}
                />
              </Box>
            </Box>
          );
          index++;
        }
        // pushing each calendar row to array
        rows.push(
          <Box
            key={index + "key"}
            display={"flex"}
            minHeight={"16.66%"}
            sx={{
              backgroundColor: "background.paper",
            }}
          >
            {row}
          </Box>
        );
      }
    }
    return rows;
  }
  return (
    <Box sx={{ marginTop: "0.8rem", overflowY: "scroll" }} height="70vh">
      {renderDates()}
    </Box>
  );
}
